import React, { useRef, useEffect } from "react";
import {
    Avatar,
    AvatarSvg,
    CategoryTitle,
    Info,
    Name,
    ResultGroup,
    ResultItem,
    ResultsList,
    ResultText,
    SearchContainer,
} from "./ExtensionSearch";
import { toAbsoluteUrl } from "_metronic/_helpers";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { result } from "lodash";

const StyledResultsList = styled(ResultsList)`
    position: absolute;
    top: 0;
    width: 300px;
    // left: 12px;
`;
const StyledCategoryTitle = styled(CategoryTitle)`
    font-size: 14px;
    color: ${colors.neutral[700]};
    font-weight: 500;
`;
const StyledResultItem = styled(ResultItem)`
    cursor: pointer;
`;

const Highlighted = styled.span`
    letter-spacing: -0.17px;
    color: #0085be;
    font-weight: 500;
`;

const TruncatedName = styled(Name)`
    min-width: initial;
`;
const ResultContainer = styled.div`
    display: flex;
    align-items: baseline;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const ExtensionFullSizeDropdown = ({
    handleResultClick,
    setIsOpen,
    isOpen,
    options,
    searchText,
    title,
    footerComponent,
}) => {
    const dropdownRef = useRef(null);

    const highlightText = (text, search) => {
        if (!search) return text;
        const regex = new RegExp(`(${search})`, "gi");
        const parts = text?.split(regex);

        return parts?.map((part, index) => (regex.test(part) ? <Highlighted key={index}>{part}</Highlighted> : part));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setIsOpen]);
    const isValidSektor = (sektor) =>
        sektor !== null && sektor !== undefined && sektor !== "null" && sektor.trim() !== "";
    return (
        <SearchContainer ref={dropdownRef}>
            <StyledResultsList isOpen={isOpen}>
                <ResultGroup>
                    <StyledCategoryTitle>{title}</StyledCategoryTitle>
                    {options.map((result, index) => (
                        <StyledResultItem key={index} onClick={() => handleResultClick(result)}>
                            {result.resim ? (
                                <Avatar src={result.resim} alt={result.ad} />
                            ) : (
                                <AvatarSvg src={toAbsoluteUrl("/media/svg/icons/Extension/user-avatar.svg")} />
                            )}
                            {console.log(result.sirket, result.sektor, ": sirket")}
                            <ResultContainer>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltip-name-${index}`}>{`${result.ad} ${result.soyad}`}</Tooltip>
                                    }
                                >
                                    <TruncatedName>
                                        {highlightText(`${result.ad} ${result.soyad}`, searchText)}
                                    </TruncatedName>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltip-name-${index}`}>
                                            {`${result.sirket ?? ""}${
                                                isValidSektor(result.sektor) ? " | " + result.sektor : ""
                                            }`}
                                        </Tooltip>
                                    }
                                >
                                    <Info>
                                        {result.sirket && result.sirket}
                                        {result.sirket && result.sektor && " | "}
                                        {result.sektor && result.sektor}
                                    </Info>
                                </OverlayTrigger>
                            </ResultContainer>
                        </StyledResultItem>
                    ))}
                    {footerComponent}
                </ResultGroup>
            </StyledResultsList>
        </SearchContainer>
    );
};

export default ExtensionFullSizeDropdown;
